import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from 'react';
import { useBKJComboBoxContext } from './BKJComboBox.context.js';
import { BKJComboBoxItem } from './BKJComboBoxItem.js';
import i18next from 'i18next';
export const BKJComboBoxOptionsMapper = ({ overrides, }) => {
    const { options, rowVirtualizer } = useBKJComboBoxContext();
    return (_jsxs(Fragment, { children: [_jsx("li", { style: { height: rowVirtualizer.totalSize } }, "total-size"), options.length > 0 ? (rowVirtualizer.virtualItems.map((virtualRow) => {
                const item = options[virtualRow.index];
                return (_jsx(BKJComboBoxItem, { ...item, overrides: overrides, index: virtualRow.index, style: {
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: virtualRow.size,
                        transform: `translateY(${virtualRow.start}px)`,
                        ...(item.groupId && !item.isGroupNode && { paddingLeft: '42px' }),
                    } }, options[virtualRow.index].id));
            })) : (_jsx(BKJComboBoxItem, { label: i18next.t('translations:NO_RESULTS'), value: "", index: 0, id: "noresults", disabled: true }) //
            )] }));
};
//# sourceMappingURL=BKJComboBoxOptionsMapper.js.map